export default __webpack_public_path__ + "static/media/watch.cd07b4d3.svg";